import { useContext, useEffect } from "react";
import { UserContext } from "../context/userContext";
import { getData } from "../fetchRoutes/getData";

export default function AuthCheck() {
  
  const url = process.env.REACT_APP_AUTH_USER;
  const { setUserDetails, setIsLoggedIn, setLoading } = useContext(UserContext);

  useEffect(() => {
    const checkAuth = async () => {
      setLoading(true);
      try {
        const response = await getData(url);

        if (!response || typeof response !== "object") {
          throw new Error("Invalid auth response format");
        }

        if (response.status?.toLowerCase() === "success") {
          const user = response.data?.freshUser;
          setUserDetails({
            name: user?.name,
            email: user?.email,
            role: user?.role,
            username: user?.username,
            savedProperties: user?.savedProperties,
            notification: user?.notification,
            image: user?.image,
            _id: user?._id,
          });
          setIsLoggedIn(true);
        } else if (response.status === 401 || response.message === "User not logged in") {
          setIsLoggedIn(false);
          setUserDetails(null);
        }
      } catch (err) {
        
        setIsLoggedIn(false);
        setUserDetails(null);
      } finally {
        setLoading(false);
      }
    };

    checkAuth();
  }, [setUserDetails, setIsLoggedIn, setLoading, url]);

  return null;
}
